<div
  *ngIf="listType !== 'calling-screen'"
  [ngStyle]="
    listType === 'createRoute' || listType === 'enroll-bus-students'
      ? { 'background-color': 'white' }
      : { 'background-color': '#fafafa' }
  "
  class="control-tab"
  [class.rtl]="currLang == 'ar'"
>
  <div
    *ngIf="
      listType !== 'pending-requests' &&
      listType !== 'available-routes-list' &&
      listType !== 'gates' &&
      listType !== 'grades' &&
      listType !== 'flows' &&
      listType !== 'createRoute' &&
      listType !== 'enroll-bus-students' &&
      listType !== 'bus-tracking' &&
      listType !== 'view-attendance' && 
      listType !== 'edit-attendance' &&
      listType !='early-dismissal-requests'&&
      listType !='sections'
    "
    class="dropdown"
  >
    <span
      *ngIf="
        listType !== 'gates' &&
        listType !== 'available-routes-list' &&
        listType !== 'flows' &&
        listType !== 'pending-requests' &&
        listType !== 'grades' &&
        listType !== 'createRoute' &&
        listType !== 'enroll-bus-students' &&
        listType !== 'bus-tracking'  && 
        listType !='early-dismissal-requests'&&
        listType !='sections'
      "
      class="show-text"
      >{{ "user-management.control-bar.show" | translate }}</span
    >
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ rowsNumberToBeShowed }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a
        (click)="changeRowsNumber(item)"
        *ngFor="let item of items"
        class="dropdown-item"
        >{{ item }}</a
      >
    </div>
  </div>
  <div
    #search
    *ngIf="
      listType !== 'gates' &&
      listType !== 'flows' &&
      listType !== 'flows' &&
      listType !== 'pending-requests'
    "
    class="search" 
    [ngStyle]="{'margin-inline-start': listType == 'early-dismissal-requests' || listType == 'sections'  ? '-1rem' :'.5rem'}"
  >
    <input
      (keyup)="searchHandler()"
      [(ngModel)]="searchInput"
      class="search-input"
      type="text"
      autocomplete="off"
      placeholder="{{ (listType === 'parents' || listType === 'staff' ? 'user-management.control-bar.search-name-id-phone' : 'user-management.control-bar.search') | translate }}"
    />
    <span
      *ngIf="searchInput !== '' && searchInput !== null"
      (click)="clearSearch()"
      class="false-icon"
      >X</span
    >
    <svg
      [class]="getSearchIconClass()"
      xmlns="http://www.w3.org/2000/svg"
      width="15.203"
      height="15.825"
      viewBox="0 -2 21.203 21.825"
      [ngStyle]="{
        left: currLang == 'ar' ? '6px' : 'initial',
        right: currLang == 'en' ? '6px' : 'initial'
      }"
    >
      <path
        id="search"
        d="M20.784,18.969l-4.956-5.155a8.4,8.4,0,1,0-6.436,3,8.318,8.318,0,0,0,4.817-1.522L19.2,20.489a1.1,1.1,0,1,0,1.581-1.52ZM9.392,2.193A6.215,6.215,0,1,1,3.177,8.408,6.222,6.222,0,0,1,9.392,2.193Z"
        transform="translate(-0.484 0.5)"
        fill="#1d71d3"
        stroke="#fff"
        stroke-width="1"
      />
    </svg>
  </div>
      <!-- Early dismissal chips and filter next to search -->
      <div *ngIf="listType == 'early-dismissal-requests'" class="d-inline-flex align-items-center">
        <div class="ed-chips">
          <span class="ed-chip" [class.selected]="earlyDismissalType==='today' && earlyDismissalStatus !='parent_arrived'" (click)="setEarlyDismissalType('today')">
            {{'user-management.early-dismissal-requests.filters.current' | translate}}
            <ng-container *ngIf="earlyDismissalType==='today' && earlyDismissalDisplayedCount">
              &nbsp;{{ earlyDismissalDisplayedCount | arabicNumber:currLang }}
            </ng-container>
          </span>
          <span class="ed-chip" [class.selected]="earlyDismissalType==='schedule'" (click)="setEarlyDismissalType('schedule')">
            {{'user-management.early-dismissal-requests.filters.scheduled' | translate}}
            <ng-container *ngIf="earlyDismissalType==='schedule' && earlyDismissalDisplayedCount">
              &nbsp;{{ earlyDismissalDisplayedCount | arabicNumber:currLang }}
            </ng-container>
          </span>
          <span class="ed-chip" [class.selected]="earlyDismissalStatus==='parent_arrived'" (click)="setEarlyDismissalParentArrived()">
            {{'user-management.early-dismissal-requests.filters.parent-arrived' | translate}}
            <ng-container *ngIf="earlyDismissalStatus==='parent_arrived' && earlyDismissalDisplayedCount">
              &nbsp;{{ earlyDismissalDisplayedCount | arabicNumber:currLang }}
            </ng-container>
          </span>
        </div>
        <div class="dropdown ml-2">
          <div
            id="early-dismissal-filter"
            class="ed-filter-trigger"
            [class.selected]="earlyDismissalStatus==='approved' || earlyDismissalStatus==='declined' || earlyDismissalStatus==='delivered' || earlyDismissalStatus==='canceled'"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="cursor:pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13.42"
              height="17.255"
              viewBox="0 0 13.42 17.255"
            >
              <g id="Filter" transform="translate(0.129 0.125)">
                <path id="Path_5374" d="M77.127,8.142A.274.274,0,0,0,76.887,8H64.274a.274.274,0,0,0-.232.421l5.167,8.159v6.5a.274.274,0,0,0,.11.219l2.194,1.645a.274.274,0,0,0,.439-.219V16.58l5.167-8.159A.274.274,0,0,0,77.127,8.142Zm-5.682,8.211a.274.274,0,0,0-.043.147v7.677l-1.645-1.234V16.5a.274.274,0,0,0-.043-.147l-4.943-7.8H76.389Z" transform="translate(-64 -8)" fill="#707070" stroke="#707070" stroke-width="0.25"/>
                <path id="Path_5375" d="M120.274,40.548h2.742a.274.274,0,0,0,0-.548h-2.742a.274.274,0,0,0,0,.548Z" transform="translate(-118.081 -38.903)" fill="#707070" stroke="#707070" stroke-width="0.25"/>
                <path id="Path_5376" d="M224.274,40.548h.274a.274.274,0,0,0,0-.548h-.274a.274.274,0,0,0,0,.548Z" transform="translate(-217.516 -38.903)" fill="#707070" stroke="#707070" stroke-width="0.25"/>
              </g>
            </svg>
            <span class="ed-filter-label" *ngIf="earlyDismissalStatus==='approved' || earlyDismissalStatus==='declined' || earlyDismissalStatus==='canceled' || earlyDismissalStatus==='delivered'" >
              {{ ('user-management.early-dismissal-requests.filters.' + earlyDismissalStatus) | translate }}
              <ng-container *ngIf="earlyDismissalDisplayedCount">
                &nbsp;{{ earlyDismissalDisplayedCount | arabicNumber:currLang }}
              </ng-container>
            </span>
          </div>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="selectEarlyDismissalStatus('approved')">{{'user-management.early-dismissal-requests.filters.approved' | translate}}</a>
            <a class="dropdown-item" (click)="selectEarlyDismissalStatus('declined')">{{'user-management.early-dismissal-requests.filters.declined' | translate}}</a>
            <a class="dropdown-item" (click)="selectEarlyDismissalStatus('delivered')">{{'user-management.early-dismissal-requests.filters.delivered' | translate}}</a>
            <!-- <a class="dropdown-item" (click)="selectEarlyDismissalStatus('canceled')">{{'user-management.early-dismissal-requests.filters.canceled' | translate}}</a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="clearEarlyDismissalFilters()">{{'user-management.early-dismissal-requests.filters.clear' | translate}}</a>
          </div>
        </div>
      </div>
  <div
    *ngIf="
      listType !== 'flows' &&
      listType !== 'pending-requests' &&
      listType !== 'bus-tracking'&&
      listType !== 'view-attendance' &&
      listType !== 'edit-attendance'&&
      listType !='early-dismissal-requests'&&
      listType !='sections'
    "
    class="show-style-control" [class.allign-left] = 'marginToggleViewLeft'
  >
    <div
      *ngIf="listType !== 'name-sounds' && listType !== 'listing'"
      class="style-control"
    >
      <!-- normal view -->
      <div
        matTooltip="{{
          'user-management.control-bar.compact-view' | translate
        }}"
      >
        <svg
          (click)="changeView(false)"
          id="normal-svg"
          [attr.class]="!compactView ? 'active' : ''"
          xmlns="http://www.w3.org/2000/svg"
          width="21.474"
          height="17"
          viewBox="0 0 21.474 17"
        >
          <g id="list_1_" data-name="list (1)" transform="translate(0 -53.333)">
            <g
              id="Group_5111"
              data-name="Group 5111"
              transform="translate(5.82 55.175)"
            >
              <g id="Group_5110" data-name="Group 5110">
                <path
                  id="Path_5426"
                  data-name="Path 5426"
                  d="M164.527,96H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                  transform="translate(-149.333 -96)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5113"
              data-name="Group 5113"
              transform="translate(5.82 61.373)"
            >
              <g id="Group_5112" data-name="Group 5112">
                <path
                  id="Path_5427"
                  data-name="Path 5427"
                  d="M164.527,245.333H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                  transform="translate(-149.333 -245.333)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5115"
              data-name="Group 5115"
              transform="translate(5.82 67.571)"
            >
              <g id="Group_5114" data-name="Group 5114">
                <path
                  id="Path_5428"
                  data-name="Path 5428"
                  d="M164.527,394.667H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                  transform="translate(-149.333 -394.667)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5117"
              data-name="Group 5117"
              transform="translate(0 65.729)"
            >
              <g id="Group_5116" data-name="Group 5116">
                <path
                  id="Path_5429"
                  data-name="Path 5429"
                  d="M2.3,352a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,352Zm0,3.683A1.381,1.381,0,1,1,3.683,354.3,1.383,1.383,0,0,1,2.3,355.683Z"
                  transform="translate(0 -352)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5119"
              data-name="Group 5119"
              transform="translate(0 59.531)"
            >
              <g id="Group_5118" data-name="Group 5118">
                <path
                  id="Path_5430"
                  data-name="Path 5430"
                  d="M2.3,202.667a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,202.667Zm0,3.683a1.381,1.381,0,1,1,1.381-1.381A1.383,1.383,0,0,1,2.3,206.35Z"
                  transform="translate(0 -202.667)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5121"
              data-name="Group 5121"
              transform="translate(0 53.333)"
            >
              <g id="Group_5120" data-name="Group 5120">
                <path
                  id="Path_5431"
                  data-name="Path 5431"
                  d="M2.3,53.333a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,53.333Zm0,3.683a1.381,1.381,0,1,1,1.381-1.381A1.383,1.383,0,0,1,2.3,57.016Z"
                  transform="translate(0 -53.333)"
                  fill="#707070"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div
        matTooltip="{{ 'user-management.control-bar.list-view' | translate }}"
      >
        <!-- compact view -->
        <svg
          *ngIf="listType !== 'bus-tracking'"
          (click)="changeView(true)"
          [attr.class]="compactView ? 'active' : ''"
          id="compact-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="20.395"
          height="14.488"
          viewBox="0 0 20.395 14.488"
        >
          <g
            id="Group_5124"
            data-name="Group 5124"
            transform="translate(6308 -176)"
          >
            <g
              id="Group_5111"
              data-name="Group 5111"
              transform="translate(-6308 176)"
            >
              <g id="Group_5110" data-name="Group 5110">
                <path
                  id="Path_5426"
                  data-name="Path 5426"
                  d="M169.128,96H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                  transform="translate(-149.333 -96)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5113"
              data-name="Group 5113"
              transform="translate(-6308 179.322)"
            >
              <g id="Group_5112" data-name="Group 5112">
                <path
                  id="Path_5427"
                  data-name="Path 5427"
                  d="M169.128,245.333H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                  transform="translate(-149.333 -245.333)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5115"
              data-name="Group 5115"
              transform="translate(-6308 182.644)"
            >
              <g id="Group_5114" data-name="Group 5114">
                <path
                  id="Path_5428"
                  data-name="Path 5428"
                  d="M169.128,394.667H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                  transform="translate(-149.333 -394.667)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5122"
              data-name="Group 5122"
              transform="translate(-6308 185.967)"
            >
              <g id="Group_5112-2" data-name="Group 5112">
                <path
                  id="Path_5427-2"
                  data-name="Path 5427"
                  d="M169.128,245.333H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                  transform="translate(-149.333 -245.333)"
                  fill="#707070"
                />
              </g>
            </g>
            <g
              id="Group_5123"
              data-name="Group 5123"
              transform="translate(-6308 189.289)"
            >
              <g id="Group_5114-2" data-name="Group 5114">
                <path
                  id="Path_5428-2"
                  data-name="Path 5428"
                  d="M169.128,394.667H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                  transform="translate(-149.333 -394.667)"
                  fill="#707070"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div
      matTooltip="{{ 'user-management.control-bar.filter' | translate }}"
      [class]="filterStatus ? 'filter-container active' : 'filter-container'"
    >
      <!-- filter -->
      <svg
        (click)="toggleFilter()"
        *ngIf="
          (listType !== 'createRoute' &&
            listType !== 'available-routes-list' &&
            listType !== 'grades' &&
            listType !== 'gates' &&
            listType !== 'assistants' &&
            listType !== 'enroll-bus-students') ||
          listType === 'name-sounds'
        "
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        id="filter-svg"
        xmlns="http://www.w3.org/2000/svg"
        width="13.42"
        height="17.255"
        viewBox="0 0 13.42 17.255"
      >
        <g id="Filter" transform="translate(0.129 0.125)">
          <path
            id="Path_5374"
            data-name="Path 5374"
            d="M77.127,8.142A.274.274,0,0,0,76.887,8H64.274a.274.274,0,0,0-.232.421l5.167,8.159v6.5a.274.274,0,0,0,.11.219l2.194,1.645a.274.274,0,0,0,.439-.219V16.58l5.167-8.159A.274.274,0,0,0,77.127,8.142Zm-5.682,8.211a.274.274,0,0,0-.043.147v7.677l-1.645-1.234V16.5a.274.274,0,0,0-.043-.147l-4.943-7.8H76.389Z"
            transform="translate(-64 -8)"
            fill="#707070"
            stroke="#707070"
            stroke-width="0.25"
          />
          <path
            id="Path_5375"
            data-name="Path 5375"
            d="M120.274,40.548h2.742a.274.274,0,0,0,0-.548h-2.742a.274.274,0,0,0,0,.548Z"
            transform="translate(-118.081 -38.903)"
            fill="#707070"
            stroke="#707070"
            stroke-width="0.25"
          />
          <path
            id="Path_5376"
            data-name="Path 5376"
            d="M224.274,40.548h.274a.274.274,0,0,0,0-.548h-.274a.274.274,0,0,0,0,.548Z"
            transform="translate(-217.516 -38.903)"
            fill="#707070"
            stroke="#707070"
            stroke-width="0.25"
          />
        </g>
      </svg>
    </div>
    <div
      id="myDropDown"
      class="dropdown-menu filter-menu"
      aria-labelledby="dropdownMenuButton"
    >
      <!-- staff Filters -->
      <ng-container *ngIf="listType === 'staff'">
        <div class="role">
          <label class="filter-header">Roles</label>
          <a *ngFor="let role of roles" class="dropdown-item">
            <mat-checkbox
              [value]="role"
              (change)="setRoleFilter($event)"
            ></mat-checkbox>
            {{ getRoleName(role) }}
          </a>
        </div>
      </ng-container>
      <!-- parents and students filters -->
      <ng-container
        *ngIf="
          listType != 'staff' ||
          (listType == 'staff' && roleFilter.includes('teacher')) ||
          (listType == 'staff' && roleFilter.includes('supervisor'))
        "
      >
        <div class="grades">
          <label class="filter-header">Grades</label>
          <a class="dropdown-item">
            <mat-checkbox
              [(ngModel)]="allGradesIsChecked"
              (change)="checkAll('grade')"
            ></mat-checkbox>
            All Grades
          </a>
          <a *ngFor="let grade of grades" class="dropdown-item">
            <mat-checkbox
              [checked]="allGradesIsChecked && grade.isSelected"
              [value]="grade"
              (change)="filterHandler('grade', $event)"
            ></mat-checkbox>
            {{ grade.name }}
          </a>
        </div>
        <ng-container
          *ngIf="
            (selectedGrades.length > 0 && !roleFilter.includes('supervisor')) ||
            (selectedGrades.length > 0 && roleFilter.includes('teacher'))
          "
        >
          <div class="classes">
            <label class="filter-header">Classes</label>
            <a class="dropdown-item">
              <mat-checkbox
                [(ngModel)]="allClassesIsChecked"
                (change)="checkAll('class')"
              ></mat-checkbox>
              All Classes
            </a>
            <a *ngFor="let class of showedClasses" class="dropdown-item">
              <mat-checkbox
                #cb
                [checked]="allClassesIsChecked"
                [checked]="class.isSelected"
                [value]="class"
                (change)="filterHandler('class', $event)"
              ></mat-checkbox>
              {{ class.name }}
            </a>
          </div>
        </ng-container>
      </ng-container>
      <!-- parents and staff filter -->
      <ng-container *ngIf="listType == 'parents' || listType == 'staff'">
        <div class="activation">
          <label class="filter-header">Activation</label>
          <a class="dropdown-item">
            <mat-checkbox
              [checked]="activation === 1"
              [value]="1"
              (change)="toggleRegAndActivationFilters('activation', $event)"
            ></mat-checkbox>
            Activated
          </a>
          <a class="dropdown-item">
            <mat-checkbox
              [checked]="activation === 0"
              [value]="0"
              (change)="toggleRegAndActivationFilters('activation', $event)"
            ></mat-checkbox>
            Not Activated
          </a>
        </div>
        <div class="registration">
          <label class="filter-header">registration</label>
          <a class="dropdown-item">
            <mat-checkbox
              [checked]="registration === 1"
              [value]="1"
              (change)="toggleRegAndActivationFilters('registration', $event)"
            >
            </mat-checkbox>
            Registered
          </a>
          <a class="dropdown-item">
            <mat-checkbox
              [checked]="registration === 0"
              [value]="0"
              (change)="toggleRegAndActivationFilters('registration', $event)"
            >
            </mat-checkbox>
            Not Registered
          </a>
        </div>
        <div class="gates" *ngIf="roleFilter.includes('security')">
          <label class="filter-header">Gates</label>
          <a *ngFor="let gate of gates" class="dropdown-item">
            <mat-checkbox
              [value]="gate"
              (change)="setGateFilter($event)"
            ></mat-checkbox>
            {{ gate.name }}
          </a>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="listType !== 'createRoute'" class="control-bar">
  
    <!-- add -->
    <div class="d-flex">
      <div class="generat-excel-container" >
        <div class="download-btn"  *ngIf="listType === 'staff'" (click)="openUpload()" [appGuardCtaByPermission]="'UploadStaffSheet'"> 
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.077"
          height="19.845"
          viewBox="0 0 18.077 19.845"
        >
          <g id="surface1" transform="translate(0.125 0.125)">
            <path
              id="Path_5771"
              data-name="Path 5771"
              d="M13.355,8.483V4.774a.429.429,0,0,0-.118-.282L9.079.127A.414.414,0,0,0,8.781,0H2.189A2.2,2.2,0,0,0,0,2.209V14.674a2.182,2.182,0,0,0,2.189,2.193h5.2a5.616,5.616,0,1,0,5.963-8.385ZM9.189,1.434,11.979,4.37H10.169a.986.986,0,0,1-.98-.984Zm-7,14.617A1.368,1.368,0,0,1,.817,14.674V2.209A1.38,1.38,0,0,1,2.189.817H8.372V3.386a1.8,1.8,0,0,0,1.8,1.8h2.369v3.19c-.122,0-.221-.016-.327-.016a5.7,5.7,0,0,0-3.725,1.4H3.3a.408.408,0,1,0,0,.817H7.727a6.5,6.5,0,0,0-.719,1.266H3.3a.408.408,0,0,0,0,.817H6.743a5.6,5.6,0,0,0,.245,3.39h-4.8Zm10.018,2.732a4.8,4.8,0,1,1,4.8-4.8A4.8,4.8,0,0,1,12.207,18.783Zm0,0"
              fill="#0074ec"
              stroke="#0074ec"
              stroke-width="0.25"
            />
            <path
              id="Path_5772"
              data-name="Path 5772"
              d="M75.959,202.5H80.1a.408.408,0,1,0,0-.817H75.959a.408.408,0,1,0,0,.817Zm0,0"
              transform="translate(-72.659 -193.965)"
              fill="#0074ec"
              stroke="#0074ec"
              stroke-width="0.25"
            />
            <path
              id="Path_5773"
              data-name="Path 5773"
              d="M248.659,283.342a.405.405,0,0,0-.6,0l-2.393,2.569a.407.407,0,0,0,.02.576.417.417,0,0,0,.584-.02l1.691-1.809v4.46a.408.408,0,1,0,.817,0v-4.46l1.678,1.809a.408.408,0,0,0,.6-.556Zm0,0"
              transform="translate(-236.162 -272.372)"
              fill="#0074ec"
              stroke="#0074ec"
              stroke-width="0.25"
            />
          </g>
        </svg>
            <span>{{'user-management.control-bar.upload' | translate}}</span>
        </div>
      </div>

      <div class="add-student-container" >
        <div class="bulk-add-btn" *ngIf="listType=='bus-students'" (click)="goToBulkAdd()">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
            <path d="M4.79595 14.2963C3.17291 14.2963 1.85718 13.1894 1.85718 11.5663C1.85718 9.94328 3.17291 8.62755 4.79595 8.62755C4.90632 8.62755 5.01527 8.63364 5.12248 8.64549V8.62755H5.1629C5.13623 8.41361 5.12248 8.19565 5.12248 7.97449C5.12248 5.08908 7.46157 2.75 10.347 2.75C12.3009 2.75 14.0043 3.82261 14.9005 5.41114C15.1195 5.37893 15.3435 5.36224 15.5715 5.36224C18.0962 5.36224 20.1429 7.40894 20.1429 9.93367C20.1429 12.012 18.756 13.5963 16.8572 14.1186M10.8557 18.25V10.75M10.8557 10.75L7.85718 13.8431M10.8557 10.75L13.8572 13.8431" stroke="#0074EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{'user-management.control-bar.bulk-upload' | translate}}</span>
        </div>
        <div class="add-student-btn" *ngIf="listType=='students'" (click)="openAddModal()" [appGuardCtaByPermission]="'StudentAdd'"> 
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.63097 8.10649C9.37491 7.97222 9.11145 7.85574 8.84214 7.75773C9.44126 7.26478 9.8841 6.57687 10.1079 5.79154C10.3316 5.00622 10.325 4.16334 10.0888 3.38241C9.8527 2.60148 9.39906 1.92213 8.79225 1.44071C8.18544 0.959278 7.45624 0.700195 6.70807 0.700195C5.95989 0.700195 5.23069 0.959278 4.62388 1.44071C4.01707 1.92213 3.56343 2.60148 3.32729 3.38241C3.09115 4.16334 3.0845 5.00622 3.30827 5.79154C3.53204 6.57687 3.97488 7.26478 4.57399 7.75773C3.43809 8.16935 2.4206 8.90241 1.62366 9.88333C0.826728 10.8643 0.278391 12.0585 0.0336952 13.3462C-0.0147046 13.6011 -0.0109208 13.8646 0.0447719 14.1176C0.100465 14.3706 0.206669 14.6068 0.355678 14.809C0.504686 15.0113 0.69276 15.1745 0.906251 15.2869C1.11974 15.3992 1.35329 15.4579 1.58995 15.4586H8.04294C8.11334 15.4614 8.18354 15.4485 8.24934 15.4208C8.31514 15.3931 8.37519 15.3511 8.4259 15.2974C8.47661 15.2436 8.51695 15.1791 8.5445 15.1077C8.57205 15.0364 8.58625 14.9597 8.58625 14.8822C8.58625 14.8047 8.57205 14.728 8.5445 14.6567C8.51695 14.5854 8.47661 14.5209 8.4259 14.4671C8.37519 14.4133 8.31514 14.3713 8.24934 14.3436C8.18354 14.3159 8.11334 14.3031 8.04294 14.3059H1.58995C1.50963 14.3063 1.43027 14.2868 1.3577 14.2489C1.28513 14.211 1.22122 14.1557 1.17067 14.0871C1.11918 14.0174 1.08258 13.9359 1.06357 13.8486C1.04456 13.7612 1.04363 13.6703 1.06084 13.5825C1.33117 12.184 2.02132 10.9261 3.02025 10.0113C4.01919 9.09645 5.26884 8.57782 6.56819 8.53883C6.61516 8.53883 6.66006 8.53883 6.70634 8.53883C6.75262 8.53883 6.80097 8.53883 6.84449 8.53883C7.65221 8.55721 8.44713 8.76442 9.17646 9.14669C9.30186 9.21238 9.44585 9.22059 9.57675 9.16951C9.70765 9.11842 9.81474 9.01223 9.87446 8.87429C9.93419 8.73635 9.94165 8.57796 9.89521 8.43397C9.84877 8.28998 9.75223 8.17218 9.62683 8.10649H9.63097ZM6.83482 7.38921H6.58131C5.9265 7.35275 5.31056 7.03629 4.86486 6.50733C4.41917 5.97838 4.179 5.27881 4.19558 4.55782C4.21216 3.83684 4.48418 3.15151 4.95362 2.64803C5.42306 2.14454 6.05276 1.86275 6.70841 1.86275C7.36406 1.86275 7.99376 2.14454 8.4632 2.64803C8.93264 3.15151 9.20466 3.83684 9.22125 4.55782C9.23783 5.27881 8.99766 5.97838 8.55196 6.50733C8.10626 7.03629 7.49032 7.35275 6.83551 7.38921H6.83482Z" fill="white"/>
            <path d="M12.8899 12.1452H11.449V10.5602C11.444 10.4109 11.3867 10.2696 11.289 10.166C11.1913 10.0623 11.0608 10.0044 10.925 10.0044C10.7893 10.0044 10.6588 10.0623 10.5611 10.166C10.4634 10.2696 10.406 10.4109 10.4011 10.5602V12.1452H8.9602C8.82454 12.1506 8.69608 12.2137 8.60184 12.3212C8.50761 12.4286 8.45496 12.5721 8.45496 12.7215C8.45496 12.8708 8.50761 13.0143 8.60184 13.1218C8.69608 13.2293 8.82454 13.2924 8.9602 13.2978H10.4011V14.8828C10.406 15.032 10.4634 15.1733 10.5611 15.277C10.6588 15.3807 10.7893 15.4386 10.925 15.4386C11.0608 15.4386 11.1913 15.3807 11.289 15.277C11.3867 15.1733 11.444 15.032 11.449 14.8828V13.2978H12.8899C13.0255 13.2924 13.154 13.2293 13.2482 13.1218C13.3425 13.0143 13.3951 12.8708 13.3951 12.7215C13.3951 12.5721 13.3425 12.4286 13.2482 12.3212C13.154 12.2137 13.0255 12.1506 12.8899 12.1452Z" fill="white"/>
            </svg>
            
            <span>{{getTipText() | translate}}</span>
        </div>

        <div class="add-student-btn" *ngIf="listType=='parents'" (click)="openAddModal()" [appGuardCtaByPermission]="'ParentAdd'">
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.63097 8.10649C9.37491 7.97222 9.11145 7.85574 8.84214 7.75773C9.44126 7.26478 9.8841 6.57687 10.1079 5.79154C10.3316 5.00622 10.325 4.16334 10.0888 3.38241C9.8527 2.60148 9.39906 1.92213 8.79225 1.44071C8.18544 0.959278 7.45624 0.700195 6.70807 0.700195C5.95989 0.700195 5.23069 0.959278 4.62388 1.44071C4.01707 1.92213 3.56343 2.60148 3.32729 3.38241C3.09115 4.16334 3.0845 5.00622 3.30827 5.79154C3.53204 6.57687 3.97488 7.26478 4.57399 7.75773C3.43809 8.16935 2.4206 8.90241 1.62366 9.88333C0.826728 10.8643 0.278391 12.0585 0.0336952 13.3462C-0.0147046 13.6011 -0.0109208 13.8646 0.0447719 14.1176C0.100465 14.3706 0.206669 14.6068 0.355678 14.809C0.504686 15.0113 0.69276 15.1745 0.906251 15.2869C1.11974 15.3992 1.35329 15.4579 1.58995 15.4586H8.04294C8.11334 15.4614 8.18354 15.4485 8.24934 15.4208C8.31514 15.3931 8.37519 15.3511 8.4259 15.2974C8.47661 15.2436 8.51695 15.1791 8.5445 15.1077C8.57205 15.0364 8.58625 14.9597 8.58625 14.8822C8.58625 14.8047 8.57205 14.728 8.5445 14.6567C8.51695 14.5854 8.47661 14.5209 8.4259 14.4671C8.37519 14.4133 8.31514 14.3713 8.24934 14.3436C8.18354 14.3159 8.11334 14.3031 8.04294 14.3059H1.58995C1.50963 14.3063 1.43027 14.2868 1.3577 14.2489C1.28513 14.211 1.22122 14.1557 1.17067 14.0871C1.11918 14.0174 1.08258 13.9359 1.06357 13.8486C1.04456 13.7612 1.04363 13.6703 1.06084 13.5825C1.33117 12.184 2.02132 10.9261 3.02025 10.0113C4.01919 9.09645 5.26884 8.57782 6.56819 8.53883C6.61516 8.53883 6.66006 8.53883 6.70634 8.53883C6.75262 8.53883 6.80097 8.53883 6.84449 8.53883C7.65221 8.55721 8.44713 8.76442 9.17646 9.14669C9.30186 9.21238 9.44585 9.22059 9.57675 9.16951C9.70765 9.11842 9.81474 9.01223 9.87446 8.87429C9.93419 8.73635 9.94165 8.57796 9.89521 8.43397C9.84877 8.28998 9.75223 8.17218 9.62683 8.10649H9.63097ZM6.83482 7.38921H6.58131C5.9265 7.35275 5.31056 7.03629 4.86486 6.50733C4.41917 5.97838 4.179 5.27881 4.19558 4.55782C4.21216 3.83684 4.48418 3.15151 4.95362 2.64803C5.42306 2.14454 6.05276 1.86275 6.70841 1.86275C7.36406 1.86275 7.99376 2.14454 8.4632 2.64803C8.93264 3.15151 9.20466 3.83684 9.22125 4.55782C9.23783 5.27881 8.99766 5.97838 8.55196 6.50733C8.10626 7.03629 7.49032 7.35275 6.83551 7.38921H6.83482Z" fill="white"/>
            <path d="M12.8899 12.1452H11.449V10.5602C11.444 10.4109 11.3867 10.2696 11.289 10.166C11.1913 10.0623 11.0608 10.0044 10.925 10.0044C10.7893 10.0044 10.6588 10.0623 10.5611 10.166C10.4634 10.2696 10.406 10.4109 10.4011 10.5602V12.1452H8.9602C8.82454 12.1506 8.69608 12.2137 8.60184 12.3212C8.50761 12.4286 8.45496 12.5721 8.45496 12.7215C8.45496 12.8708 8.50761 13.0143 8.60184 13.1218C8.69608 13.2293 8.82454 13.2924 8.9602 13.2978H10.4011V14.8828C10.406 15.032 10.4634 15.1733 10.5611 15.277C10.6588 15.3807 10.7893 15.4386 10.925 15.4386C11.0608 15.4386 11.1913 15.3807 11.289 15.277C11.3867 15.1733 11.444 15.032 11.449 14.8828V13.2978H12.8899C13.0255 13.2924 13.154 13.2293 13.2482 13.1218C13.3425 13.0143 13.3951 12.8708 13.3951 12.7215C13.3951 12.5721 13.3425 12.4286 13.2482 12.3212C13.154 12.2137 13.0255 12.1506 12.8899 12.1452Z" fill="white"/>
            </svg>

            <span>{{getTipText() | translate}}</span>
        </div>

        <div class="add-student-btn" *ngIf="listType=='staff'" (click)="openAddModal()" [appGuardCtaByPermission]="'StaffAdd'">
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.63097 8.10649C9.37491 7.97222 9.11145 7.85574 8.84214 7.75773C9.44126 7.26478 9.8841 6.57687 10.1079 5.79154C10.3316 5.00622 10.325 4.16334 10.0888 3.38241C9.8527 2.60148 9.39906 1.92213 8.79225 1.44071C8.18544 0.959278 7.45624 0.700195 6.70807 0.700195C5.95989 0.700195 5.23069 0.959278 4.62388 1.44071C4.01707 1.92213 3.56343 2.60148 3.32729 3.38241C3.09115 4.16334 3.0845 5.00622 3.30827 5.79154C3.53204 6.57687 3.97488 7.26478 4.57399 7.75773C3.43809 8.16935 2.4206 8.90241 1.62366 9.88333C0.826728 10.8643 0.278391 12.0585 0.0336952 13.3462C-0.0147046 13.6011 -0.0109208 13.8646 0.0447719 14.1176C0.100465 14.3706 0.206669 14.6068 0.355678 14.809C0.504686 15.0113 0.69276 15.1745 0.906251 15.2869C1.11974 15.3992 1.35329 15.4579 1.58995 15.4586H8.04294C8.11334 15.4614 8.18354 15.4485 8.24934 15.4208C8.31514 15.3931 8.37519 15.3511 8.4259 15.2974C8.47661 15.2436 8.51695 15.1791 8.5445 15.1077C8.57205 15.0364 8.58625 14.9597 8.58625 14.8822C8.58625 14.8047 8.57205 14.728 8.5445 14.6567C8.51695 14.5854 8.47661 14.5209 8.4259 14.4671C8.37519 14.4133 8.31514 14.3713 8.24934 14.3436C8.18354 14.3159 8.11334 14.3031 8.04294 14.3059H1.58995C1.50963 14.3063 1.43027 14.2868 1.3577 14.2489C1.28513 14.211 1.22122 14.1557 1.17067 14.0871C1.11918 14.0174 1.08258 13.9359 1.06357 13.8486C1.04456 13.7612 1.04363 13.6703 1.06084 13.5825C1.33117 12.184 2.02132 10.9261 3.02025 10.0113C4.01919 9.09645 5.26884 8.57782 6.56819 8.53883C6.61516 8.53883 6.66006 8.53883 6.70634 8.53883C6.75262 8.53883 6.80097 8.53883 6.84449 8.53883C7.65221 8.55721 8.44713 8.76442 9.17646 9.14669C9.30186 9.21238 9.44585 9.22059 9.57675 9.16951C9.70765 9.11842 9.81474 9.01223 9.87446 8.87429C9.93419 8.73635 9.94165 8.57796 9.89521 8.43397C9.84877 8.28998 9.75223 8.17218 9.62683 8.10649H9.63097ZM6.83482 7.38921H6.58131C5.9265 7.35275 5.31056 7.03629 4.86486 6.50733C4.41917 5.97838 4.179 5.27881 4.19558 4.55782C4.21216 3.83684 4.48418 3.15151 4.95362 2.64803C5.42306 2.14454 6.05276 1.86275 6.70841 1.86275C7.36406 1.86275 7.99376 2.14454 8.4632 2.64803C8.93264 3.15151 9.20466 3.83684 9.22125 4.55782C9.23783 5.27881 8.99766 5.97838 8.55196 6.50733C8.10626 7.03629 7.49032 7.35275 6.83551 7.38921H6.83482Z" fill="white"/>
            <path d="M12.8899 12.1452H11.449V10.5602C11.444 10.4109 11.3867 10.2696 11.289 10.166C11.1913 10.0623 11.0608 10.0044 10.925 10.0044C10.7893 10.0044 10.6588 10.0623 10.5611 10.166C10.4634 10.2696 10.406 10.4109 10.4011 10.5602V12.1452H8.9602C8.82454 12.1506 8.69608 12.2137 8.60184 12.3212C8.50761 12.4286 8.45496 12.5721 8.45496 12.7215C8.45496 12.8708 8.50761 13.0143 8.60184 13.1218C8.69608 13.2293 8.82454 13.2924 8.9602 13.2978H10.4011V14.8828C10.406 15.032 10.4634 15.1733 10.5611 15.277C10.6588 15.3807 10.7893 15.4386 10.925 15.4386C11.0608 15.4386 11.1913 15.3807 11.289 15.277C11.3867 15.1733 11.444 15.032 11.449 14.8828V13.2978H12.8899C13.0255 13.2924 13.154 13.2293 13.2482 13.1218C13.3425 13.0143 13.3951 12.8708 13.3951 12.7215C13.3951 12.5721 13.3425 12.4286 13.2482 12.3212C13.154 12.2137 13.0255 12.1506 12.8899 12.1452Z" fill="white"/>
            </svg>
            
            <span>{{getTipText() | translate}}</span>
        </div>

        <div class="add-student-btn" [class.big-btn]="listType=='bus-students'"  *ngIf="listType=='bus-students'" (click)="openAddModal()"> 
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.63097 8.10649C9.37491 7.97222 9.11145 7.85574 8.84214 7.75773C9.44126 7.26478 9.8841 6.57687 10.1079 5.79154C10.3316 5.00622 10.325 4.16334 10.0888 3.38241C9.8527 2.60148 9.39906 1.92213 8.79225 1.44071C8.18544 0.959278 7.45624 0.700195 6.70807 0.700195C5.95989 0.700195 5.23069 0.959278 4.62388 1.44071C4.01707 1.92213 3.56343 2.60148 3.32729 3.38241C3.09115 4.16334 3.0845 5.00622 3.30827 5.79154C3.53204 6.57687 3.97488 7.26478 4.57399 7.75773C3.43809 8.16935 2.4206 8.90241 1.62366 9.88333C0.826728 10.8643 0.278391 12.0585 0.0336952 13.3462C-0.0147046 13.6011 -0.0109208 13.8646 0.0447719 14.1176C0.100465 14.3706 0.206669 14.6068 0.355678 14.809C0.504686 15.0113 0.69276 15.1745 0.906251 15.2869C1.11974 15.3992 1.35329 15.4579 1.58995 15.4586H8.04294C8.11334 15.4614 8.18354 15.4485 8.24934 15.4208C8.31514 15.3931 8.37519 15.3511 8.4259 15.2974C8.47661 15.2436 8.51695 15.1791 8.5445 15.1077C8.57205 15.0364 8.58625 14.9597 8.58625 14.8822C8.58625 14.8047 8.57205 14.728 8.5445 14.6567C8.51695 14.5854 8.47661 14.5209 8.4259 14.4671C8.37519 14.4133 8.31514 14.3713 8.24934 14.3436C8.18354 14.3159 8.11334 14.3031 8.04294 14.3059H1.58995C1.50963 14.3063 1.43027 14.2868 1.3577 14.2489C1.28513 14.211 1.22122 14.1557 1.17067 14.0871C1.11918 14.0174 1.08258 13.9359 1.06357 13.8486C1.04456 13.7612 1.04363 13.6703 1.06084 13.5825C1.33117 12.184 2.02132 10.9261 3.02025 10.0113C4.01919 9.09645 5.26884 8.57782 6.56819 8.53883C6.61516 8.53883 6.66006 8.53883 6.70634 8.53883C6.75262 8.53883 6.80097 8.53883 6.84449 8.53883C7.65221 8.55721 8.44713 8.76442 9.17646 9.14669C9.30186 9.21238 9.44585 9.22059 9.57675 9.16951C9.70765 9.11842 9.81474 9.01223 9.87446 8.87429C9.93419 8.73635 9.94165 8.57796 9.89521 8.43397C9.84877 8.28998 9.75223 8.17218 9.62683 8.10649H9.63097ZM6.83482 7.38921H6.58131C5.9265 7.35275 5.31056 7.03629 4.86486 6.50733C4.41917 5.97838 4.179 5.27881 4.19558 4.55782C4.21216 3.83684 4.48418 3.15151 4.95362 2.64803C5.42306 2.14454 6.05276 1.86275 6.70841 1.86275C7.36406 1.86275 7.99376 2.14454 8.4632 2.64803C8.93264 3.15151 9.20466 3.83684 9.22125 4.55782C9.23783 5.27881 8.99766 5.97838 8.55196 6.50733C8.10626 7.03629 7.49032 7.35275 6.83551 7.38921H6.83482Z" fill="white"/>
            <path d="M12.8899 12.1452H11.449V10.5602C11.444 10.4109 11.3867 10.2696 11.289 10.166C11.1913 10.0623 11.0608 10.0044 10.925 10.0044C10.7893 10.0044 10.6588 10.0623 10.5611 10.166C10.4634 10.2696 10.406 10.4109 10.4011 10.5602V12.1452H8.9602C8.82454 12.1506 8.69608 12.2137 8.60184 12.3212C8.50761 12.4286 8.45496 12.5721 8.45496 12.7215C8.45496 12.8708 8.50761 13.0143 8.60184 13.1218C8.69608 13.2293 8.82454 13.2924 8.9602 13.2978H10.4011V14.8828C10.406 15.032 10.4634 15.1733 10.5611 15.277C10.6588 15.3807 10.7893 15.4386 10.925 15.4386C11.0608 15.4386 11.1913 15.3807 11.289 15.277C11.3867 15.1733 11.444 15.032 11.449 14.8828V13.2978H12.8899C13.0255 13.2924 13.154 13.2293 13.2482 13.1218C13.3425 13.0143 13.3951 12.8708 13.3951 12.7215C13.3951 12.5721 13.3425 12.4286 13.2482 12.3212C13.154 12.2137 13.0255 12.1506 12.8899 12.1452Z" fill="white"/>
            </svg>
            
            <span>{{getTipText() | translate}}</span>
        </div>
      </div>

      <div [matTooltip]="getTipText()">
        <svg
          *ngIf="
            listType !== 'gates' &&
            listType !== 'available-routes-list' &&
            listType !== 'grades' &&
            listType !== 'flows' &&
            listType !== 'pending-requests' &&
            listType !== 'parents' &&
            listType !== 'assistants' &&
            listType !== 'students' &&
            listType !== 'staff' &&
            listType !== 'routes' &&
            listType !== 'enroll-bus-students' &&
            listType !== 'bus-students' &&
            listType !== 'bus-tracking' &&
            listType !== 'name-sounds' &&
            listType !== 'listing'&&
            listType !== 'view-attendance' &&
            listType !== 'edit-attendance' && 
            listType !='early-dismissal-requests'&&
            listType !='sections'
          "
          (click)="openAddModal()"
          class="add-btn"
          xmlns="http://www.w3.org/2000/svg"
          width="19.677"
          height="19.67"
          viewBox="0 0 19.677 19.67"
        >
          <g
            id="Group_5219"
            data-name="Group 5219"
            transform="translate(-1277.369 -118.369)"
          >
            <g id="add" transform="translate(1277.5 118.494)">
              <g id="Group_1840" data-name="Group 1840" transform="translate(0)">
                <g id="Group_1839" data-name="Group 1839">
                  <path
                    id="Path_5041"
                    data-name="Path 5041"
                    d="M13.926,9.744a9.827,9.827,0,0,0-1.142-.459,5.158,5.158,0,1,0-6.179,0A9.87,9.87,0,0,0,.032,16.64a2.308,2.308,0,0,0,2.253,2.78h9.342a.759.759,0,1,0,0-1.517H2.285a.777.777,0,0,1-.607-.288.789.789,0,0,1-.159-.664,8.385,8.385,0,0,1,7.973-6.638c.068,0,.133,0,.2,0s.137,0,.2,0a8.245,8.245,0,0,1,3.376.8.758.758,0,0,0,.652-1.369ZM9.878,8.8H9.511a3.639,3.639,0,1,1,.368,0Z"
                    transform="translate(0.018)"
                    fill="#707070"
                    stroke="#fafafa"
                    stroke-width="0.25"
                  />
                </g>
              </g>
              <g
                id="Group_1842"
                data-name="Group 1842"
                transform="translate(12.214 12.214)"
              >
                <g id="Group_1841" data-name="Group 1841">
                  <path
                    id="Path_5042"
                    data-name="Path 5042"
                    d="M328.448,324.845h-2.086v-2.086a.759.759,0,0,0-1.517,0v2.086h-2.086a.759.759,0,0,0,0,1.517h2.086v2.086a.759.759,0,0,0,1.517,0v-2.086h2.086a.759.759,0,0,0,0-1.517Z"
                    transform="translate(-322 -322)"
                    fill="#707070"
                    stroke="#fafafa"
                    stroke-width="0.25"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div >
      <!-- [matTooltip]="getTipText()" -->
      <!-- add grade or class -->
      <button *ngIf="listType === 'grades' || listType === 'flows' || listType === 'gates'"
      (click)="openAddModal()" class="btn btn-primary add-btn add-button"> + {{getTipText()}}</button>
    </div>
  </div>
</div>

<ng-container
  *ngIf="
    selectedGrades.length > 0 ||
    activation !== -1 ||
    registration !== -1 ||
    roleFilter.length > 0
  "
>
  <mat-chip-set #chipList>
    <mat-chip
      *ngFor="let route of selectedRoutes"
      [value]="route"
      (removed)="removeRouteFilterFromChips($event)"
    >
      {{ route.route_name }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip
      *ngFor="let gate of selectedGates"
      [value]="gate"
      (removed)="removeGateFilterFromChips($event)"
    >
      {{ gate.name }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip
      *ngFor="let role of roleFilter"
      [value]="role"
      (removed)="removeRoleFromChips($event)"
    >
      {{ role }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip
      *ngFor="let grade of selectedGrades"
      [value]="grade"
      (removed)="removeHandler('grade', $event)"
    >
      {{ grade.name }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip
      *ngFor="let class of selectedClasses"
      [value]="class"
      (removed)="removeHandler('class', $event)"
    >
      {{ class.name }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip
      *ngIf="activation === 1"
      (removed)="toggleRegAndActivationFilters('activation', $event)"
    >
      Activated
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip
      *ngIf="activation === 0"
      (removed)="toggleRegAndActivationFilters('activation', $event)"
    >
      Not Activated
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip
      *ngIf="registration === 1"
      (removed)="toggleRegAndActivationFilters('registration', $event)"
    >
      Registered
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip
      *ngIf="registration === 0"
      (removed)="toggleRegAndActivationFilters('registration', $event)"
    >
      Not Registered
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-set>
</ng-container>
